import Icon from "@sproutsocial/seeds-react-icon";
import React from "react";

import {
  AutocompleteInput,
  type TypeAutocompleteInputProps,
} from "./AutocompleteInput";
import styled from "styled-components";
import { Accessory } from "@sproutsocial/seeds-react-input";

const StyledAutocompleteInput = styled(AutocompleteInput)`
  ${Accessory} {
    pointer-events: none;
  }
`;

export const AutocompleteSelect = (props: TypeAutocompleteInputProps) => {
  return (
    <StyledAutocompleteInput
      elemAfter={<Icon name="chevron-down" />}
      {...props}
    />
  );
};
